export function meOf(couple, slot) {
  const p = slot === "a" ? couple.partner_a : couple.partner_b;
  return p || {};
}

export function partnerOf(couple, slot) {
  const p = slot === "a" ? couple.partner_b : couple.partner_a;
  return p || {};
}

export function daysBetween(fromISO, toISO) {
  const a = new Date(fromISO);
  const b = new Date(toISO);
  return Math.round((b - a) / 86400000);
}
